<template>
    <section class="">
        <!-- 1アイテム -->
        <div v-for="content in favorite_list" class="favorite_box_par">
            <div class="favorite_box">
                <div class="favorite_image_box"><img :src="content.image" alt="" class="favorite_image"></div>
                <div class="favorite_title_box" @click="jumpContentPlayer(content.destination, content.playable_status)">
                    <!-- <div class="">{{ content.type_op}}</div> -->
                    <div class="favorite_title">{{ content.title }}</div>
                    <div class="favorite_unplayable" v-show="content.playable_status==0">{{ characters.favorite_unplayable }}</div>
                </div>
                <div class="favorite_del_box">
                    <div class="favorite_del" @click="removeContent(content.favorite_id)"><p class="favorite_del_button">{{ characters.remove }}</p></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "favorite-list",
        props: ['json_characters'],
        data: function () {
            return {
                favorite_list: [],
                characters: Object,
            }
        },
        mounted() {
            this.getFavoriteList();
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            jumpContentPlayer: function(destination, playable_status) {
                if(playable_status == 1) {
                    location.href=destination;
                }
            },
            getFavoriteList: function() {
                axios.default
                    .get('/favorite/content/get')
                    .then(response => {
                        this.favorite_list = response.data.favorite_list;
                    });
            },
            removeContent: function(favorite_id) {
                axios.default
                    .get('/favorite/content/remove/'+favorite_id)
                    .then(response => {
                        if(response.data.error_message) {
                            alert(response.data.error_message);
                            return;
                        }
                        this.getFavoriteList();
                    });
            },
        },
    }
</script>

<style scoped>
</style>
